import AdaptiveQuiz from './AdaptiveQuiz';

export default AdaptiveQuiz;
